import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import SimpleBar from "simplebar-react";

import { isEmpty, map, size } from "lodash";

import PropTypes from "prop-types";

import { Link, withRouter } from "react-router-dom";
import image from "assets/images/companies/img-1.png";

import {
  Badge,
  Col,
  Container,
  Row,
  Table,
  Card,
  CardBody,
  Button,
} from "reactstrap";

//Import Breadcrumb

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import { getUnreadNotifications, MarkAsRead } from "store/Notifications/actions";

class NotificationDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.props.onGetNotifications();
  }
  componentDidUpdate(prevProps, prevState) {
  
    // if (
    //   isEmpty(notifications) &&
    //   size(notifications) !== size(prevState.notifications)
    // ) {
    //   console.log("empty notifs");
    //   // this.setState({ notifications });
    // }
    // if (size(notifications) !== size(prevState.notifications)) {
    //   // this.setState({ notifications });
    //   console.log("notifications after update", notifications);
    // } else if (
    //   JSON.stringify(notifications) !== JSON.stringify(prevState.notifications)
    // ) {
    //   console.log("update stringify true");
    //   // this.setState({ notifications });
    //   console.log("notifications after update", notifications);
    // }
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }));
  }

  RedirectNotification=(type,id)=>{
    if(type==="Lab Verification"){
      console.log("type clicked:",type)
      this.props.history.push(`/pendingverifications`);
    }
  
    else{
    
    }

  }
  render() {
    const { notifications } = this.props;
  

    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="dropdown d-inline-block"
          tag="li"
        >

<DropdownToggle
            className="btn header-item noti-icon"
            tag="button"
            id="page-header-notifications-dropdown"
          >
            <i className="bx bx-bell bx-tada" />
            <span className="badge bg-danger rounded-pill">{this.props.notifications.length}</span>
          </DropdownToggle>


          <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> Notifications </h6>
                </Col>
                <div className="col-auto">
                  <Link to="/notifications" className="small">
                    {" "}
                    View All
                  </Link>
                </div>
              </Row>
            </div>

            <SimpleBar style={{ height: "230px" }}>
              {!this.props.isLoading && isEmpty(this.props.notifications) ? (
              
                <div className="text-center justify-items-center">
                  <h6> No unread Notications</h6>
                  <div className="col-auto">
                  <Link to="/notifications" className="small">
                    {" "}
                    View Previous Notifications
                  </Link>
                </div>
                </div>
                

              ) : 
                null }

              {/* {notifications.map((notification, key) => ( */}
              {!this.props.isLoading ? (
                notifications.map((notif, key) => (
                  // this.state.notifications.map((notif, key) => (
                  <div key={key}>
                    <Link
                      to="#"
                      className="text-reset notification-item"
                      onClick={() => {
                       
                        this.props.onMarkAsRead(JSON.parse(localStorage.getItem("authUser")).refresh_token,notif.id);
                        this.RedirectNotification(notif.Data.type, notif.Data.id);
                      }}
                    >
                      <div className="d-flex">
                        <div className="avatar-xs me-3">
                          <span className="avatar-title bg-primary rounded-circle font-size-16">
                            <i className="fas fa-bell" />
                          </span>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mt-0 mb-1">
                            {notif.Title}
                        
                          </h6>
                          <div className="font-size-12 text-muted">
                            <p className="mb-1">
                              {notif.Body}
              
                            </p>
                            <p className="mb-0">
                              <i className="mdi mdi-clock-outline" />{" "}
                              {notif.Date}
              
                            </p>
                           
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))
              ) : (
                <div className="text-center">
                  <p>No NOTIFICATIONS YET</p>
                </div>
              )}
            </SimpleBar>
            <div className="p-2 border-top d-grid">
              <Link
                className="btn btn-sm btn-link font-size-14 text-center"
                to="#"
               
              >
                <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
                <span key="t-view-more">
              
                </span>
              </Link>
            </div>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
  onGetNotifications: PropTypes.func,
  notifications: PropTypes.array,
  isLoading: PropTypes.bool,
  history: PropTypes.object,
  onMarkAsRead: PropTypes.func,
};

const mapStateToProps = state => ({


  isLoading: state.NotificationsReducer.isLoading,
  notifications: state.NotificationsReducer.unreadnotifications,
});

const mapDispatchToProps = dispatch => ({
  onGetNotifications: () => {
    dispatch(getUnreadNotifications());
  },
  onMarkAsRead: (token,id) => {
    dispatch(MarkAsRead(token,id));
  } 

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NotificationDropdown));
